export default "__VITE_ASSET__DnKrSGA$__"